<template>
  <div class="modal fade" id="requestPayout" tabindex="-1" aria-labelledby="requestPayoutLabel"
       aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <validation-observer ref="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="requestPayoutLabel">Payout options</h5>
            <button type="button" class="btn-close" id="closePayoutOptions" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p class="amount-txt">Amount</p>
            <div class="top d-flex align-items-center justify-content-between">
              <div class="payout-amount d-flex align-items-center">
                <div class="amount">
                  <span class="amount-val">
                    <span class="usd">$</span>
                    <input class="amount-input" type="number" v-model="form.amount" placeholder="0.00">
                  </span>
                </div>
                <div class="remaining-balance">
                  <p>Remaining Balance</p>
                  <span class="value"><span class="usd">$</span> {{ remainingAmount }}</span>
                </div>
              </div>
              <button :disabled="!canWithdraw" :style="{opacity: canWithdraw ? '1' : '0.5'}" @click="requestPayout" class="send-request main-btn">
                <span>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                       xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M15.8334 11.698V5.0564C15.8334 4.14318 15.0834 3.396 14.1667 3.396H2.50004C1.58337 3.396 0.833374 4.14318 0.833374 5.0564V11.698C0.833374 12.6112 1.58337 13.3584 2.50004 13.3584H14.1667C15.0834 13.3584 15.8334 12.6112 15.8334 11.698ZM14.1665 11.6978H2.49984V5.0562H14.1665V11.6978ZM19.1665 15.0187V5.88653H17.4999V15.0187H3.33321V16.6791H17.4999C18.4165 16.6791 19.1665 15.932 19.1665 15.0187Z"
                          fill="white" />
                    <path
                        d="M8.90631 9.58564C8.93265 9.42269 8.90236 9.28185 8.81544 9.16312C8.72853 9.0444 8.55009 8.93149 8.28012 8.82441C8.01016 8.71732 7.78694 8.6114 7.61047 8.50664C7.07054 8.18539 6.82033 7.76287 6.85984 7.23908C6.88881 6.83868 7.05869 6.51102 7.36948 6.25611C7.68027 6.0012 8.08719 5.85047 8.59025 5.80391L8.75223 5.05664H9.37249L9.20656 5.82486C9.6069 5.89935 9.91177 6.07628 10.1212 6.35563C10.3305 6.63498 10.4287 6.99698 10.4155 7.44161L9.29743 7.43812C9.32904 6.88873 9.14599 6.61054 8.74828 6.60355C8.54021 6.5989 8.36506 6.65535 8.22284 6.77291C8.08061 6.89047 7.99501 7.0447 7.96604 7.23559C7.94233 7.38458 7.97197 7.51611 8.05493 7.63017C8.1379 7.74424 8.29724 7.85133 8.53297 7.95143C8.76869 8.05153 8.96689 8.14465 9.12755 8.23078C9.75703 8.56601 10.0507 9.0153 10.0086 9.57866C9.97959 9.98372 9.81036 10.3108 9.50089 10.5599C9.19142 10.809 8.7812 10.9568 8.27024 11.0034L8.11617 11.6982H7.49985L7.65393 10.9999C7.19038 10.9393 6.83679 10.763 6.59317 10.4708C6.34954 10.1787 6.23563 9.80447 6.25143 9.34819L7.36553 9.35168C7.35236 9.63336 7.40438 9.84521 7.52158 9.98721C7.63879 10.1292 7.81459 10.2025 8.049 10.2072C8.27288 10.2119 8.46383 10.1566 8.62186 10.0413C8.77989 9.9261 8.8747 9.7742 8.90631 9.58564Z"
                        fill="white" />
                  </svg>
                </span>
                <span>Send Request</span>
              </button>
            </div>
            <validation-provider name="gateway" v-slot="{ errors }">
              <div class="invalid-feedback" style="display: block">{{ errors[0] }}</div>
            </validation-provider>

            <div>
              <div class="form-check" v-if="$auth.user().payout_paypal.length > 0">
                <input class="form-check-input" type="radio" value="paypal" v-model="form.payout" name="flexRadioDefault" id="flexRadioDefault1"
                       checked />
                <label class="form-check-label" for="flexRadioDefault1">
                  <span class="payment-name">Paypal</span>
                  <span class="payment-info">{{ $auth.user().payout_paypal }}</span>
                </label>
              </div>
              <div class="form-check" v-if="$auth.user().payout_bitcoin.length > 0">
                <input class="form-check-input" type="radio" value="bitcoin" v-model="form.payout" name="flexRadioDefault" id="flexRadioDefault2" />
                <label class="form-check-label" for="flexRadioDefault2">
                  <span class="payment-name">Bitcoin</span>
                  <span class="payment-info">{{ $auth.user().payout_bitcoin }}</span>
                </label>
              </div>
              <div class="form-check" v-if="$auth.user().payout_usdt.length > 0">
                <input class="form-check-input" type="radio" value="usdt" v-model="form.payout" name="flexRadioDefault" id="flexRadioDefault3" />
                <label class="form-check-label" for="flexRadioDefault3">
                  <span class="payment-name">USDT TRC20</span>
                  <span class="payment-info">{{ $auth.user().payout_usdt }}</span>
                </label>
              </div>
            </div>
            <div v-if="!hasPayoutOptions">
              <h3 class="text-center mt-5">No payment options</h3>
            </div>
          </div>
        </div>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import {Transaction} from "@/models"
import {formatCents} from "@/helpers"
import API from "@/api"
const api = new API()
export default {
  name: "RequestPayout",
  data() {
    return {
      form: {
        payout: 'paypal',
        amount: 0.0
      }
    }
  },
  mounted() {
    const modal = document.getElementById('requestPayout')
    modal.addEventListener('shown.bs.modal', this.onVisible)
    modal.addEventListener('hidden.bs.modal', this.onHidden)
  },
  computed: {
    hasPayoutOptions() {
      return this.$auth.user().payout_paypal.length > 0 || this.$auth.user().payout_bitcoin.length > 0 || this.$auth.user().payout_usdt.length > 0
    },
    canWithdraw() {
      return this.$auth.user().earnings_current > 0 &&
          (this.$auth.user().payout_paypal.length > 0 || this.$auth.user().payout_bitcoin.length > 0 || this.$auth.user().payout_usdt.length > 0)
    },
    hasEnoughMoney() {
      return this.$auth.user().earnings_current >= this.$auth.user().earnings_payout
    },
    remainingAmount() {
      let amount = this.$auth.user().earnings_current - parseInt(this.form.amount * 100, 10)
      if (amount < 0) {
        amount = 0
      }

      return formatCents(amount)
    }
  },
  methods: {
    onVisible() {
      this.form.payout = 'paypal'

      if (this.$auth.user().payout_paypal.length > 0) {
        return
      }

      if (this.$auth.user().payout_bitcoin.length > 0) {
        this.form.payout = 'bitcoin'
        return
      }

      if (this.$auth.user().payout_usdt.length > 0) {
        this.form.payout = 'usdt'
      }
    },
    onHidden() {
      this.form.amount = 0.0
    },
    onClose() {
      this.form.payout = 'paypal'
    },
    requestPayout() {
      this.$refs.form.reset()

      this.$wait.start('payout_request')
      api.requestPayout(this.form.payout, this.form.amount)
        .then(r => Transaction.insertOrUpdate({
          data: r.data
        }))
        .then(() => this.$auth.fetch())
        .then(() => {
          this.onClose()
          document.getElementById('closePayoutOptions').click()
        })
        .catch(r => this.$refs.form.setErrors(r.response.data))
        .finally(() => this.$wait.end('payout_request'))
    }
  }
}
</script>
